import "./App.css";
import { Container, Nav, Navbar, NavLink, NavDropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faMoon, faSun, faDesktop } from "@fortawesome/free-solid-svg-icons";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/Home";
import DataFetch from "./controller/dataFetch";
import React, { createContext } from "react";
import MainCardNoSide from "./components/MainCardNoSide";
import "bootstrap/dist/css/bootstrap.min.css";
import CaseOverview from "./pages/CaseOverview";
import * as CaseOverviewViews from "./pages/CaseOverviewViews";
import ModuleCreate from "./pages/ModuleCreate";
import CaseCreate from "./pages/CaseCreate";
import StudentMain from "./students/pages/StudentMain";
import StudentSubmissionReview from "./students/pages/StudentSubmissionReview";
import DraftEditor from "./students/pages/DraftEditor";
import Change from "./pages/change";
import Register from "./pages/register";
import Accounts from "./pages/Accounts";
import PasswordMigration from "./pages/PasswordMigration";
import TwoFactorSetup from "./pages/TwoFactorSetup";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import UserSettings from "./pages/UserSettings";
import { useTheme } from "./context/ThemeContext";

export const userContext = createContext(0);
export const accountContext = createContext(0);
export const selectionContext = createContext({});
function App() {
  new DataFetch().init(); // initiate datafetch

  const [userC, setUserC] = React.useState(null);
  const [accountC, setaccountC] = React.useState(null);
  const [selectionC, setselectionC] = React.useState(null);

  const { theme, setTheme, effectiveTheme } = useTheme();

  function signout() {
    localStorage.clear();
  }

  const currentThemeIcon = effectiveTheme === 'dark' ? faMoon : faSun;

  return (
    <Router>
      <div
        className="App"
        style={{ position: "relative", height: "100vh", overflow: "hidden" }}
      >
        <Navbar style={{ zIndex: "150" }} bg={effectiveTheme === 'dark' ? 'dark' : 'primary'} variant="dark">
          <Container fluid={true}>
            <Navbar.Brand href="/">
              <img
                alt=""
                src="/logo.svg"
                width="30"
                height="30"
                className="d-inline-block align-top"
              />{" "}
              Panoptes
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Nav className="me-auto" style={{ marginLeft: "auto" }}>
              {/*<NavbarBreadcrums/>*/}
            </Nav>
            <Nav className="text-white align-items-center">
              {localStorage.getItem("role")?.includes("ADMIN") && (
                <NavLink href="/accounts">Accounts</NavLink>
              )}
              <NavLink href="/user-settings">
                <FontAwesomeIcon icon={faUser} /> Profile
              </NavLink>
              <NavLink onClick={signout} href="/login">
                Sign out
              </NavLink>
              <NavDropdown
                title={<FontAwesomeIcon icon={currentThemeIcon} />}
                id="theme-switcher"
                align="end"
                className="theme-switcher-dropdown"
              >
                <NavDropdown.Item
                  onClick={() => setTheme('light')}
                  active={theme === 'light'}
                >
                  <FontAwesomeIcon icon={faSun} className="me-2" />
                  Light
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => setTheme('dark')}
                  active={theme === 'dark'}
                >
                  <FontAwesomeIcon icon={faMoon} className="me-2" />
                  Dark
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => setTheme('system')}
                  active={theme === 'system'}
                >
                  <FontAwesomeIcon icon={faDesktop} className="me-2" />
                  System
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Container>
        </Navbar>
        <Container
          fluid={true}
          style={{ height: "calc(100% - 56px)", overflowY: "auto" }}
        >
          <userContext.Provider value={{ userC, setUserC }}>
            <accountContext.Provider value={{ accountC, setaccountC }}>
              <selectionContext.Provider value={{ selectionC, setselectionC }}>
                <Routes>
                  <Route
                    path="/student/:studentnumber/case/:caseId/draft/:draftId"
                    element={<DraftEditor />}
                  />
                  <Route
                    path="/student/:studentnumber/submission/:submission"
                    element={<StudentSubmissionReview />}
                  />
                  <Route
                    path="/student/:studentnumber"
                    element={<StudentMain />}
                  />
                  <Route
                    path="/login"
                    element={<MainCardNoSide element={<Login />} />}
                  />
                  <Route
                    path="/register"
                    element={<MainCardNoSide element={<Register />} />}
                  />
                  <Route
                    path="/credentials"
                    element={<MainCardNoSide element={<Change />} />}
                  />
                  <Route
                    path="/password-migration"
                    element={<MainCardNoSide element={<PasswordMigration />} />}
                  />
                  <Route
                    path="/2fa-setup"
                    element={<MainCardNoSide element={<TwoFactorSetup />} />}
                  />
                  <Route
                    path="/reset-password"
                    element={<MainCardNoSide element={<ResetPassword />} />}
                  />
                  <Route
                    path="/forgot-password"
                    element={<MainCardNoSide element={<ForgotPassword />} />}
                  />
                  <Route path="/user-settings" element={<UserSettings />} />
                  <Route path="/case/create/:module" element={<CaseCreate />} />
                  <Route path="/case/:caseid/" element={<CaseOverview />}>
                    <Route
                      path="students"
                      element={<CaseOverviewViews.Students />}
                    />
                    <Route
                      path="viewer"
                      element={<CaseOverviewViews.Viewer />}
                    />
                    <Route
                      path="histogram"
                      element={<CaseOverviewViews.Histogram />}
                    />
                    <Route
                      path="goldenstandard"
                      element={<CaseOverviewViews.GoldenStandard />}
                    />
                    <Route path="rules" element={<CaseOverviewViews.Rules />} />
                    <Route path="edit" element={<CaseOverviewViews.Edit />} />
                    <Route path="" element={<Navigate to="students" />} />
                  </Route>
                  <Route path="/case" element={<Navigate to="/" />} />
                  <Route path="/module/create" element={<ModuleCreate />} />
                  <Route path="/module" element={<Navigate to="/" />} />
                  <Route path="/accounts" element={<Accounts />} />
                  <Route path="/" element={<Home />} />
                </Routes>
              </selectionContext.Provider>
            </accountContext.Provider>
          </userContext.Provider>
        </Container>
      </div>
    </Router>
  );
}

export default App;
